import React from 'react';
// import ChatWidget from '../component/ChatWidget/ChatWidget';
import PeopleCard from '../component/PeopleOnMove/PeopleCard';
import Footer from '../component/Footer/FooterCommon';
import Navbar from '../component/Navbar/NavbarCommon';
import ArrowButton from '../component/Common/ArrowButton';

const LeadershipTeam = () => {
    const leaders = [
        {
            id: 1,
            name: "Parag Kulkarni",
            position: "SVP International & President",
            promotedAs: "34 Yrs Experience",
            movedTo: "AOS - Since 2015",
            image: "assets/LeaderOne.svg"
        },
        {
            id: 2,
            name: "Sivaprasad Sake",
            position: "Director - Operations",
            promotedAs: "30 Yrs Experience",
            movedTo: "AOS - Since 2013",
            image: "assets/LeaderTwo.svg"
        },
        {
            id: 3,
            name: "Ashish Kaul",
            position: "Director, Customer & Sales",
            promotedAs: "22 Yrs Experience",
            movedTo: "AOS - Since 2013",
            image: "assets/LeaderThree.svg"
        },
        {
            id: 4,
            name: "Dr. Neeraj Gupta",
            position: "Director - R&D",
            promotedAs: "26 Yrs Experience",
            movedTo: "AOS - Since 2014",
            image: "assets/LeaderFour.svg"
        }
    ];

    return (
        <>
            <div className="min-h-screen flex flex-col overflow-x-hidden">
                <Navbar />
                <div className="flex-grow py-4 lg:py-6 px-4 lg:px-10 mt-12 md:mt-20 lg:mt-20 xl:mt-20 font-poppins overflow-x-hidden">
                        <ArrowButton />
                    <div className="mx-auto max-w-8x py-5 md:py-0">
                        {/* Header Section */}
                        <div className="mb-8 sm:mb-12 md:mb-16 lg:mb-5 xl:mb-10 lg:mt-5 xl:mt-10 text-center sm:text-left">
                            <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-semibold text-black mb-3 sm:mb-4 leading-tight">
                                <span className="text-navgreen">Meet</span> Our Leadership Team
                            </h1>
                            <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-gray-600 font-medium leading-relaxed max-w-4xl">
                                The people behind our purpose-leading AO Smith India into the future.
                            </p>
                        </div>

                        {/* Leadership Cards Grid - Using PeopleCard structure */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-4 md:gap-5 lg:gap-7 xl:gap-6 w-full overflow-visible pt-3">
                            {leaders.map((leader) => (
                                <PeopleCard
                                    key={leader.id}
                                    leader={leader}
                                    showClockIcon={true}  
                                />
                            ))}
                        </div>
                    </div>
                </div>

                {/* ChatWidget with Tailwind style overrides */}
                <div className="[&>div>div]:!bg-white [&>div>div]:!border [&>div>div]:!border-gray-200 [&>div>div:hover]:!bg-gray-50">
                    {/* <ChatWidget /> */}
                </div>

                <Footer />
            </div>
        </>
    );
};

export default LeadershipTeam;